import { defineStyleConfig } from "@chakra-ui/react";
import { variantOptions } from "./themeOptions";

const FillLayout = defineStyleConfig({
  baseStyle: () => ({
    w: "full",
    h: "full",
    display: "flex",
    flexDirection: "column",
  }),
  variants: {
    [variantOptions.white]: () => {
      return {
        backgroundColor: 'surfaces.lifted.white',
      };
    },
    [variantOptions.soft]: () => {
      return {
        backgroundColor: 'surfaces.lifted.soft',
      };
    },
    [variantOptions.strong]: () => {
      return {
        backgroundColor: 'surfaces.lifted.strong',
      };
    },
  },
  defaultProps: {
    variant: variantOptions.white,
  },
});

export default FillLayout;
